import React, { useEffect, useState } from "react";
import {
  FormGroup,
  Input,
  Row,
  Col,
  Label,
  Card,
  CardBody,
  CardFooter,
} from "reactstrap";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useKey } from "../../../services/useKey";
import SOURCES from "../../../utils/constants";
import SubmitButton from "../../common/submitButton";
import useGet from "../../../services/useGet";
import CommonForm from "../../global/form";
import { Button, Form, message } from "antd";
import CommonCard from "../../global/card";

const AdvanceSearchUser = ({
  setShowAdvanceSearch,
  setAdvanceSearch,
  advanceSearch,
  getAdvanceSearchData,
  paymentPlans,
}) => {
  const [searched, setSearched] = useState(false);
  const [form] = Form.useForm();

  const {
    callApi: getLeadSourcesOptions,
    data: leadSource,
    isLoading: getLeadSourcesOptionsLoader,
  } = useGet({
    endpoint: `leadsource/options`,
  });

  const getPlans = () => {
    if (Array.isArray(paymentPlans) && paymentPlans.length > 0) {
      return paymentPlans?.map((item) => ({
        label: item.planName,
        value: item._id,
      }));
    }
    return [];
  };

  const getLeadSourse = () => {
    if (Array.isArray(leadSource) && leadSource.length > 0) {
      return leadSource?.map((item) => ({
        label: item.title,
        value: item.key,
      }));
    }
    return [];
  };

  useKey(() => setSearched(true), "Enter");
  useKey(() => {
    setShowAdvanceSearch(false);
    setAdvanceSearch({
      ...advanceSearch,
      advance_search_enabled: searched
        ? SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_CLOSED_SEARCH_FORM
        : SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
    });
  }, "Escape");

  useEffect(() => {
    getLeadSourcesOptions();
  }, []);

  // useEffect(() => {
  //   if (searched === true) {
  //     console.log("searched", searched);
  //     setAdvanceSearch({
  //       ...advanceSearch,
  //       advance_search_enabled:
  //         SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_FILTER,
  //     });
  //     setSearched(false);
  //   }
  // }, [searched]);

  // useEffect(() => {
  //   console.log(
  //     "inside call efect",
  //     advanceSearch.advance_search_enabled ===
  //       SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_FILTER
  //   );
  //   console.log("advance search inside effetc", advanceSearch);
  //   if (
  //     advanceSearch.advance_search_enabled ===
  //     SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_FILTER
  //   ) {
  //     getAdvanceSearchData();
  //     setAdvanceSearch({
  //       ...advanceSearch,
  //       advance_search_enabled:
  //         SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_DO_NOT_CALL_API_PARENT,
  //     });
  //   }
  // }, [advanceSearch.advance_search_enabled, advanceSearch]);

  console.log(advanceSearch);

  const onSearch = () => {
    form
      .validateFields()
      .then(async (values) => {
        console.log("Form values:", values);
        console.log(
          Object.values(values).every(
            (v) => v === "" || typeof v === "undefined"
          )
        );
        if (
          Object.values(values).every(
            (v) => v === "" || typeof v === "undefined"
          )
        ) {
          // all values empty
          setAdvanceSearch({
            ...advanceSearch,
            advance_search_enabled:
              SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
          });
          message.error("Please fill at least one field.");
          return;
        }
        console.log(advanceSearch);
        setAdvanceSearch({
          ...advanceSearch,
          plan: values.plan || "",
          status: values.status || "",
          trial: values.trial || "",
          userStatus: values.userStatus || "",
          leadSource: values.leadSource || "",
          verified: values.verified,
          advance_search_enabled:
            SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_FILTER,
        });
      })
      .catch((err) => {
        console.log("Validation failed", err);
      });
  };

  const formData = [
    {
      label: "Plan",
      name: "plan",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Select One",
      required: false,
      message: "Plan is required.",
      options: getPlans(),
    },
    {
      label: "Verified",
      name: "verified",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Select One",
      required: false,
      message: "Verified status is required.",
      options: [
        { label: "Verified", value: "y" },
        { label: "Unverified", value: "n" },
      ],
    },
    {
      label: "Trial",
      name: "trial",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Select One",
      required: false,
      message: "Trial status is required.",
      options: [
        { label: "Yes", value: "y" },
        { label: "No", value: "n" },
      ],
    },
    {
      label: "Status",
      name: "status",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Select One",
      required: false,
      message: "Status is required.",
      options: [
        { label: "Active", value: "active" },
        { label: "Deleted", value: "deleted" },
        { label: "Suspended", value: "suspended" },
        { label: "Trial", value: "trial" },
        { label: "Trial End", value: "trial_end" },
      ],
    },
    {
      label: "Lead Source",
      name: "leadSource",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Select One",
      required: false,
      message: "Lead source is required.",
      options: getLeadSourse(),
      span: 24,
    },
  ];

  return (
    <>
      {/* <Card className="shadow">
        <CardBody>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <Label for="plan">Plan</Label>
                <Input
                  type="select"
                  value={advanceSearch.plan}
                  tabIndex={1}
                  autoFocus={true}
                  id="plan"
                  name="plan"
                  className=" w-100 p-2 mt-2 border rounded"
                  onChange={(e) =>
                    setAdvanceSearch({
                      ...advanceSearch,
                      plan: e.target.value,
                    })
                  }
                >
                  <option value="">Select One</option>
                  {paymentPlans &&
                    paymentPlans.map((plan) => {
                      return <option value={plan._id}>{plan.planName}</option>;
                    })}
                </Input>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="verified">Verified</Label>
                <Input
                  type="select"
                  value={advanceSearch.status}
                  tabIndex={2}
                  autoFocus={true}
                  id="verified"
                  name="verified"
                  className="w-100 p-2 mt-2 border rounded"
                  onChange={(e) =>
                    setAdvanceSearch({
                      ...advanceSearch,
                      status: e.target.value,
                    })
                  }
                >
                  <option value="">Select One</option>
                  <option value="y">Verified</option>
                  <option value="n">Unverified</option>
                </Input>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="trial">Trial</Label>
                <Input
                  type="select"
                  value={advanceSearch.trial}
                  tabIndex={3}
                  autoFocus={true}
                  id="trial"
                  name="trial"
                  className="w-100 p-2 mt-2 border rounded"
                  onChange={(e) =>
                    setAdvanceSearch({
                      ...advanceSearch,
                      trial: e.target.value,
                    })
                  }
                >
                  <option value="">Select One</option>
                  <option value="y">Yes</option>
                  <option value="n">No</option>
                </Input>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="status">Status</Label>
                <Input
                  type="select"
                  value={advanceSearch.userStatus}
                  tabIndex={4}
                  autoFocus={true}
                  id="status"
                  name="status"
                  className="w-100 p-2 mt-2 border rounded"
                  onChange={(e) =>
                    setAdvanceSearch({
                      ...advanceSearch,
                      userStatus: e.target.value,
                    })
                  }
                >
                  <option value="">Select One</option>
                  <option value="active">Active</option>
                  <option value="deleted">Deleted</option>
                  <option value="suspended">Suspended</option>
                  <option value="trial">Trial</option>
                  <option value="trial_end">Trial End</option>
                </Input>
              </FormGroup>
            </Col>

            <Col sm={6}>
              <FormGroup>
                <Label for="leadSource">Lead Source</Label>
                <Input
                  type="select"
                  value={advanceSearch.leadSource}
                  tabIndex={5}
                  autoFocus={true}
                  id="leadSource"
                  name="leadSource"
                  className="w-100 p-2 mt-2 border rounded"
                  onChange={(e) =>
                    setAdvanceSearch({
                      ...advanceSearch,
                      leadSource: e.target.value,
                    })
                  }
                >
                  <option value="">Select One</option>
                  {leadSource &&
                    leadSource.map((ls) => (
                      <option value={ls.key}>{ls.title}</option>
                    ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <CardFooter>
            <FormGroup>
              <SubmitButton
                title="Search"
                icon={faSearch}
                tabIndex={6}
                tabIndexCancelButton={7}
                onClick={() => {
                  setSearched(true);
                }}
                cancleButtonOnClick={() => {
                  setShowAdvanceSearch(false);
                  setAdvanceSearch({
                    ...advanceSearch,
                    advance_search_enabled: searched
                      ? SOURCES.ADVANCE_SEARCH_FIELDS
                          .SEARCH_TYPE_CLOSED_SEARCH_FORM
                      : SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
                  });
                }}
              />

              needs to be commented out
              <Button color="primary" onClick={() => {
                setSearched(true)
              }}>
                <FontAwesomeIcon icon={faSearch} className="mr-2" />
                Search
              </Button>
              <Button color="secondary" className="ml-2" onClick={() => {
                setShowAdvanceSearch(false);
                setAdvanceSearch({ ...advanceSearch, advance_search_enabled: searched ? SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_CLOSED_SEARCH_FORM : SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER })
              }}
              >
                <FontAwesomeIcon icon={faTimes} className="mr-2" />
                Close
              </Button>
              needs to be commented out
            </FormGroup>
          </CardFooter>
        </CardBody>
      </Card> */}

      <CommonCard
        title="Advance Search"
        isExtraButton={{
          show: [
            "plan",
            "status",
            "trial",
            "userStatus",
            "leadSource",
            "verified",
          ].some((key) => advanceSearch[key] && advanceSearch[key] !== ""),
          title: "Clear",
          onClick: () => {
            console.log("advanceSearch", advanceSearch);
            setAdvanceSearch({
              ...advanceSearch,
              plan: "",
              status: "",
              trial: "",
              userStatus: "",
              leadSource: "",
              verified: "",
              advance_search_enabled:
                SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
            });
            form.resetFields();
          },
        }}
        className={"max-w-[650px] w-full shadow-2xl"}
      >
        <CommonForm
          data={formData}
          // onSubmit={(values) => console.log(values)}
          className="mt-4"
          layoutType="vertical"
          form={form}
        />
        <div className="flex justify-end">
          <Button
            key="confirm"
            type="primary"
            className="!bg-primary text-white h-10 min-w-[130px]"
            onClick={onSearch}
          >
            Search
          </Button>
        </div>
      </CommonCard>
    </>
  );
};

export default AdvanceSearchUser;
